import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_ERROR } from "./actions";
import { getCurrentToken, getCurrentUser , getCurrentRefreshToken } from "../../helpers/utility";

const INIT_STATE = {
  currentUser: getCurrentUser(),
  currentToken: getCurrentToken(),
  currentRefreshToken: getCurrentRefreshToken(),
  loading: false,
  error: "",
};

const authReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: "" };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentToken: action.payload,
        error: "",
      };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentToken: null,
        error: action.payload.message,
      };
    default:
      return state;
  }
};

export default authReducer;
